import React from "react";
import styles from "./label.module.scss";
const LightweightLabel = ({ className, children, noPadding, dataTestId }) => {
    return (React.createElement("div", { className: `${styles.vhvLabel} ${className} ${noPadding ? styles.noPadding : ""}`, "data-testid": dataTestId }, children));
};
export default LightweightLabel;
